export default function() {
  const env = process.env.REACT_APP_API_URL
  if (env.includes('rc')) {
    return 'rc'
  }
  if (env.includes('dev')) {
    return 'dev'
  }

  return 'prod'
}
